module.exports = __webpack_public_path__ + "img/edit.5a74b303.svg";